import type { VoidFunctionComponent } from 'react';
import * as _ from 'lodash';
import type { MinimalDependencyLock, Path } from './useDependencyPaths';
import Locator from '../../../../../shared/Locator';
import { renderPackage, renderRevision } from '../../../../../shared/helpers/renderLocator';
import { trimString } from '../../../../utils';
import Icon, { icons } from '../../../generic/Icon';

import styles from './ModalViewRelationships.module.less';

type Props = {
  baseRevision: string;
  groupedPaths: Path[][];
  projectTitle: string | null;
  dependencyLocks: Record<string, MinimalDependencyLock>;
};

const Relationships: VoidFunctionComponent<Props> = ({
  baseRevision,
  groupedPaths,
  projectTitle,
  dependencyLocks,
}) => {
  const baseRevLoc = new Locator(baseRevision);
  const dependencyLock = dependencyLocks[baseRevision];
  const sortedGroupPaths = _.sortBy(groupedPaths, p => p.length);

  const originPaths = dependencyLock?.originPaths ?? [];
  const nonCurrentDirectoryOriginPaths = originPaths.filter((path) => path !== '.');

  return (
    <ul className="list-min" key={baseRevLoc.package.value}>
      <li key={`dep_id_${baseRevLoc.package.value}`} className="header">
        <b>
          <b>{dependencyLock?.project?.title || renderPackage(baseRevLoc)}
          </b> ({trimString(renderRevision(baseRevLoc), 10)})
        </b>
        <small>
          <ul className={styles.originPaths}>
            {nonCurrentDirectoryOriginPaths.map((path, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={`dep_id_${baseRevLoc.package.value}_path_${i}`}>
                <code className={styles.originPath}>
                  {path}
                </code>
              </li>
            ))}
          </ul>
        </small>
      </li>
      {sortedGroupPaths.map((path, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={`full_dep_path_${i}`} className="hover-highlight">
          {path.slice(0, -1).map(({ locator, title }) => {
            return (
              <span className="margin-right-xs" key={`dep-path-${locator}`}>
                <span className="badge margin-right-xs">
                  {title || renderPackage(Locator.parse(locator))}
                </span>
                <Icon icon={icons.angleRight} />
              </span>
            );
          })}
          <b>{projectTitle}</b>
        </li>
      ))}
    </ul>
  );
};

export default Relationships;
